<template>
  <el-dialog @close='close' :title="title" :visible.sync="dialogVisible" width="500px" >
    <el-form ref="added" :model="formData1" :rules="rules1" size="medium" inline>
      <el-form-item label="姓名：" prop="user_name" class="h">
        {{ formData1.user_name }}
      </el-form-item>
      <el-form-item label="性别：" prop="user_sex" class="h">
       {{ formData1.user_sex | isSex }}
      </el-form-item>
      <el-form-item label="手机号：" prop="user_phone" class="h">
        {{ formData1.user_phone }}
      </el-form-item>
      <!-- <el-form-item label="所属区域" prop="area_code">
        <el-cascader v-model="formData1.village_code" disabled :options="areaList" clearable :props="{ 
          expandTrigger: 'hover',
          children: 'child',
          label:'area_name',
          value:'area_code'
        }"></el-cascader>
      </el-form-item> -->
      <el-form-item label="身份：" prop="user_role" class="h">
        <span v-if="formData1.is_volunteer == 1">志愿者、</span>
        <span v-if="formData1.user_role == 1">普通用户</span>
        <span v-if="formData1.user_role == 2">社工</span>
      </el-form-item>
      <el-form-item label="报名活动："></el-form-item>
      <div style="margin-bottom: 20px;">
        <el-table
            :data="list"
            stripe
            border
            :header-row-style="{
              color: '#666'
            }"
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="活动名称"
            >
            </el-table-column>
            <el-table-column
              label="分类"
              align="center"
              width="180">
              <template slot-scope="scope">
                <span>{{  scope.row.type | activity_type }}</span>
              </template>
            </el-table-column>
          </el-table>
        <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
          :total="query.total">
        </el-pagination>
      </div>
      
      <el-form-item label="参与招聘："></el-form-item>
      <div>
        <el-table
            :data="recruitList"
            stripe
            border
            :header-row-style="{
              color: '#666'
            }"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="招聘名称"
            >
            </el-table-column>
          </el-table>
        <el-pagination style="margin: 30px auto;text-align: center;" v-if="recruitQuery.total > 0"
          @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="recruitQuery.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="recruitQuery.page_limit" layout="total, sizes, prev, pager, next, jumper"
          :total="recruitQuery.total">
        </el-pagination>
      </div>
      
    </el-form>
    <span class="flex-ct" style="padding-top: 30px;">
      <el-button @click="close">关 闭</el-button>
      <!-- <el-button type="primary" @click="handelConfirm">确 定</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default{
    data(){
      var validatorPhone = function(rule, value, callback) {
        if (!/^1[23456789]\d{9}$/.test(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      return{
        title: "用户详情",
        dialogVisible: false,
        formData1: {},
        rules1: { //弹窗 正则
          user_name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          user_sex: [{
            required: true,
            message: '请选择性别',
            trigger: ['change', 'blur']
          }],
          user_phone: [{
            required: true,
            message: '请输入手机号：',
            trigger: 'blur'
          }, {
            message: '手机号格式有误',
            validator: validatorPhone,
            trigger: 'blur'
          }],
          area_code: [{
            required: true,
            message: '请选择区域',
            trigger: 'change'
          }],
          user_role: [{
            required: true,
            message: '请选择身份',
            trigger: 'change'
          }],
        },
        areaList: [],
        list: [],
        query: {
           page_limit: 10,
           page: 1,
           total: 0,
           userId: ''
         },
         recruitList: [],
         recruitQuery: {
            page_limit: 10,
            page: 1,
            total: 0,
            userId: ''
          },
      }
    },
    methods:{
      async show(row){
        this.formData1 = row
        this.query.userId = row.user_id
        this.recruitQuery.userId = row.user_id
        await this.getList();
        await this.getRecruitList()
        this.dialogVisible = true
      },
      getList() {
        userInfoAPI.userActivityEnrollList(this.query).then(res => {
          if(res.data.code == 0){
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      },
      
      getRecruitList() {
        userInfoAPI.userRecruitmentDeliveryList(this.recruitQuery).then(res => {
          if(res.data.code == 0){
            this.recruitList = res.data.data.list || []
            this.recruitQuery.total = res.data.data.page.count || 0
          }
        })
      },
      handleSizeChange1(val) {
        this.recruitQuery.page_limit = val;
        this.getRecruitList();
      },
      handleCurrentChange1(val) {
        this.recruitQuery.page = val;
        this.getRecruitList();
      },
      
      close() { //弹窗关闭
        this.$refs['added'].resetFields(); //强制清理表格内容 
        this.dialogVisible = false;
      },
      
      getAreaList() {
        userInfoAPI.systemSelectionList().then(({
          data
        }) => {
          this.areaList = data.data || []
        })
      },
      handleChange(e) {
        if (e[0]) {
          this.formData1.area_code = e[0]
          this.formData1.village_code = e[1]
        } else {
          this.formData1.area_code = ''
          this.formData1.village_code = ''
        }
      },
      handelConfirm() {
        this.$refs['added'].validate(valid => {
          if (valid) {
            if(this.formData1.user_id){
              userInfoAPI.serviceUserEdit(this.formData1).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: data.msg
                  });
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg
                  })
                }
              })
            }else{
              userInfoAPI.serviceUserAdd(this.formData1).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: data.msg
                  });
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg
                  })
                }
              })
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .el-form-item.h{
    width: 40%;
  }
</style>